module.exports = __webpack_public_path__ + "static/restaurantes-9eaa5b81c1ea52443b220e35579c4070.svg";